import { render } from "./LiveEventOfferSettings.vue?vue&type=template&id=7def1248"
import script from "./LiveEventOfferSettings.vue?vue&type=script&lang=js"
export * from "./LiveEventOfferSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__